import React from 'react';

export interface FmAvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  label?: string;
  icon?: React.ReactNode;
  size?: 'sm' | 'md';
  tone?: 'neutral' | 'accent';
}

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

function initials(label?: string): string {
  const words = (label ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  return words.slice(0, 2).map((word) => word[0]?.toUpperCase()).join('');
}

export const FmAvatar: React.FC<FmAvatarProps> = ({
  label,
  icon,
  size = 'md',
  tone = 'neutral',
  className,
  ...rest
}) => (
  <span
    className={cx(
      'fm-avatar',
      size === 'sm' && 'fm-avatar--sm',
      tone === 'accent' && 'fm-avatar--accent',
      className,
    )}
    aria-hidden={rest['aria-label'] ? undefined : true}
    {...rest}
  >
    {icon ? <span className="fm-avatar__icon">{icon}</span> : initials(label)}
  </span>
);

export default FmAvatar;
